import { Typography } from '@mui/material';

type YoutubeStatsTooltipSeriesValueProps = {
  value: number;
  variant: 'body2' | 'caption';
  alignSelf?: 'flex-start' | 'flex-end';
};

/**
 * Shared numeric value renderer for YouTube stats tooltips.
 */
export function YoutubeStatsTooltipSeriesValue(props: YoutubeStatsTooltipSeriesValueProps) {
  const { value, variant, alignSelf } = props;

  return (
    <Typography
      variant={variant}
      sx={{
        fontWeight: 'bold',
        minWidth: '9ch',
        textAlign: 'right',
        fontVariantNumeric: 'tabular-nums',
        ...(alignSelf ? { alignSelf } : {}),
      }}
    >
      {value.toLocaleString()}
    </Typography>
  );
}
